import { ThunkDispatch } from "core-integration/src/store";
import { clearCode, setCode } from "core-integration/src/store/leagues/thunks";
import { getPlayerData } from "core-integration/src/store/player/reducers";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router";

// AutoJoin component simply stores the code in local storage and redirects
// the user somewhere sensible.

const AutoJoin: React.FC = () => {
  const { code } = useParams();
  const navigate = useNavigate();
  const player = useSelector(getPlayerData);
  const dispatch = useDispatch<ThunkDispatch>();

  const next =
    player && player.entry ? "/my-team" : player ? "/squad-selection" : "/";

  useEffect(() => {
    if (code) {
      dispatch(setCode(code));
    } else {
      dispatch(clearCode());
    }
    navigate(next, { replace: true });
  });

  return <div />;
};

export default AutoJoin;
